import React from "react";
import { AnimatePresence, motion, useReducedMotion } from "framer-motion";

export default function PageTransition({ children, pageKey }) {
  const reducedMotion = useReducedMotion();

  if (reducedMotion) {
    return <div className="w-full min-w-0 overflow-x-hidden">{children}</div>;
  }

  return (
    <AnimatePresence mode="sync" initial={false}>
      <motion.div
        key={pageKey || "page"}
        className="w-full min-w-0 overflow-x-hidden"
        initial={{ opacity: 0, y: 4 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.12, ease: [0.2, 0, 0, 1] }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}